import { Collection } from "@tblabs/truffle";
import { Expanse } from "../Models/Expanse";
import { RawExpanse } from "../Models/RawExpanse";
import { OnlineRepo } from "./Storage/OnlineRepo";


export class ExpansesRepo
{
    public Expanses = new Collection<Expanse>();

    constructor(private _expansesRepo: OnlineRepo<RawExpanse[]>) { }

    public async Update(): Promise<void>
    {
        await this._expansesRepo.Update("", "expanses", this.Expanses.Items.map(x => x.ToRaw()));
    }

    public async Download(): Promise<void>
    {
        let rawExpanses: RawExpanse[] | null = await this._expansesRepo.GetOne("", "expanses");

        if (!rawExpanses)
        {
            rawExpanses = [];
        }

        const expanses = rawExpanses?.map(x => new Expanse(x)) || [];

        this.Expanses.Load(...expanses);
    }
}
